<template>
  <div class="gallery-container">
    <SectionTop :id="3" />
    <!-- 全フォルダから最大15件取得 -->
    <Masonary :limit="15" folder="All" class="scroll-animation" v-scroll-animation />
    <ViewMore :id="3" customClass="view-more-wrapper-gallery" />
  </div>
</template>

<script>
import SectionTop from '@/features/home/components/SectionTop.vue';
import Masonary from '@/features/common/Masonary.vue';
import ViewMore from '@/features/home/components/ViewMore.vue';

export default {
  components: {
    SectionTop,
    Masonary,
    ViewMore,
  }
};
</script>

<style scoped>
.gallery-container {
  position: relative;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-bottom: 100px;
}

.view-more-wrapper-gallery {
  bottom: 10px;
  z-index: 10;
}

@media screen and (max-width: 570px) {
  .gallery-container {
    gap: 20px;
    margin-bottom: 50px;
  }
}
</style>